import { useGetAllCryptoCurrency, useGetTotalAsset } from "../../api/currency";

const useHomepage = (search: string, method: string, enabled = true) => {
  const {
    data = {
      data: {
        data: [],
      },
    },
    isLoading: isLoadingCrypto,
    refetch: refetchCryptoCurrency,
  } = useGetAllCryptoCurrency(search, method, enabled);

  const {
    data: totalAsset = { data: { data: 0 } },
    refetch: refetchTotalAsset,
  } = useGetTotalAsset(enabled);

  return {
    dataAllCrypto: data.data.data,
    refetchCryptoCurrency,
    isLoadingCrypto,
    totalAsset: totalAsset.data.data,
    refetchTotalAsset,
  };
};

export default useHomepage;
